/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionPromptsControllerUpdateMutationRequest, TemplateQuestionPromptsControllerUpdateMutationResponse, TemplateQuestionPromptsControllerUpdatePathParams, TemplateQuestionPromptsControllerUpdate400, TemplateQuestionPromptsControllerUpdate401, TemplateQuestionPromptsControllerUpdate403, TemplateQuestionPromptsControllerUpdate404 } from "../../models/checklistsController/TemplateQuestionPromptsControllerUpdate";

function getTemplateQuestionPromptsControllerUpdateUrl(id: TemplateQuestionPromptsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-template-question-prompts/${id}` as const }  
  return res
}

/**
 * @summary Update a checklist template question prompt
 * {@link /api/v1/checklist-template-question-prompts/:id}
 */
export async function templateQuestionPromptsControllerUpdate(id: TemplateQuestionPromptsControllerUpdatePathParams["id"], data?: TemplateQuestionPromptsControllerUpdateMutationRequest, config: Partial<RequestConfig<TemplateQuestionPromptsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateQuestionPromptsControllerUpdateMutationResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerUpdate400 | TemplateQuestionPromptsControllerUpdate401 | TemplateQuestionPromptsControllerUpdate403 | TemplateQuestionPromptsControllerUpdate404>, TemplateQuestionPromptsControllerUpdateMutationRequest>({ method : "PATCH", url : getTemplateQuestionPromptsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}